import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-change-preview-modal',
  templateUrl: './change-preview-modal.component.html',
  styleUrls: ['./change-preview-modal.component.scss']
})
export class ChangePreviewModalComponent implements OnInit {
  @Input() oldData: any = {};
  @Input() newData: any = {};
  @Input() config: any[] = [];
  @Input() title: string = 'Confirm Changes';
  /** 'audit' renders read-only (Close button only, no Confirm & Submit) - used
   * when this modal is showing a past audit_log entry rather than a pending
   * edit awaiting confirmation. Defaults to 'preview' so every existing caller
   * (tab-head's saveModification(), FormChangePreviewService) is unaffected. */
  @Input() mode: 'preview' | 'audit' = 'preview';

  public onClose: Subject<boolean> = new Subject();

  constructor(public bsModalRef: BsModalRef, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  setInput(data: any) {
    if (data) {
        this.oldData = data.oldData || {};
        this.newData = data.newData || {};
        this.config = data.config || [];
        if (data.title) this.title = data.title;
        if (data.mode) this.mode = data.mode;

        // Force change detection so the child app-change-preview receives
        // the new Input bindings and triggers ngOnChanges immediately!
        this.cdr.detectChanges();
    }
  }

  confirm() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  cancel() {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
}
